/**
 * @file
 * Fullcalendar View plugin JavaScript file.
 */

(function ($, Drupal) {
  Drupal.behaviors.etbuFullCalendar = {
    attach: function (context, settings) {
      $('#calendar', context).fullCalendar('option', 'eventClick', function (calEvent, jsEvent, view) {
        if (drupalSettings.linkToEntity) {
          return true;
        }

        return false;
      });
    }
  }
})(jQuery, Drupal);
